import fetchData from '../api.js';

export const removeProduct = async(item) => {

  let postData = {};
  postData.action = 'remove_product';
  postData.token  = token
  postData.id     = item.id;
  let response = await fetchData(postData);
  if (response.success==1) {    
    return true;     
  }
  return false;

}

export const addProduct = async(item) => {

  let postData = {};
  postData.action = 'add_product';
  postData.token  = token
  postData.id     = item.id;
  let response = await fetchData(postData);
  if (response.success==1) {    
    return true;     
  }
  return false;
}